import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

type BudgetFundsToolbarProps = {
  search: string;
  onSearchChange: (value: string) => void;
  fiscalYear: string;
  onFiscalYearChange: (value: string) => void;
  yearOptions: number[];
  activeFilter: string;
  onActiveFilterChange: (value: string) => void;
  total: number;
};

export function BudgetFundsToolbar({
  search,
  onSearchChange,
  fiscalYear,
  onFiscalYearChange,
  yearOptions,
  activeFilter,
  onActiveFilterChange,
  total,
}: BudgetFundsToolbarProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
      <div className="relative min-w-0 flex-1 sm:max-w-xs">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <Input
          type="search"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search funds..."
          className="pl-9"
        />
      </div>
      <Select value={fiscalYear} onValueChange={onFiscalYearChange}>
        <SelectTrigger className="w-[120px]">
          <SelectValue placeholder="Fiscal year" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All years</SelectItem>
          {yearOptions.map((y) => (
            <SelectItem key={y} value={String(y)}>
              FY {y}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={activeFilter} onValueChange={onActiveFilterChange}>
        <SelectTrigger className="w-[120px]">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All</SelectItem>
          <SelectItem value="active">Active</SelectItem>
          <SelectItem value="inactive">Inactive</SelectItem>
        </SelectContent>
      </Select>
      <span className="text-sm text-slate-500">
        {total} fund{total !== 1 ? "s" : ""}
      </span>
    </div>
  );
}
